import { RouteMap } from 'routes/router';

export const chatSubroutes = {
    messaging: 'messaging',
    new: 'new'
} as const satisfies RouteMap;
